import React from 'react';
import GrayCard from '../../../components/GrayCardCorporateOpportunities';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import C3Chart from 'react-c3js';
import 'c3/c3.css';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import './Opportunities.css';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import 'react-toastify/dist/ReactToastify.min.css';
import {
    getOpportunitiesCards, getSalesRebateOpportunitiesTrend, getOpportunitiesByRegion,
    getOpportunitiesUnapprovedSupplierVolumeByMember, getOpportunitiesVendorPartnerVolume,
    getOpportunitiesUnapprovedProductGroup, saveOutVendorFeedback, getTerminatedVPNamesForCorporate,
    insertFeedbackUnapprovedSupplierFeedback, getStateRegions, getLPGNamesForMember,
    getStateToStateMapping, regionCodeNameMapping, getCorporateOpportunityMonthsFilter, tabTracking
} from '../../../actions';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _isEqual from 'lodash/isEqual';
import Filters from '../../../components/Filters.jsx';
import Modal from '../../../components/Modal';
import { Card, Form, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import _find from 'lodash/find';
import { Dropdown } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import { get } from 'http';
import { getCardTitle } from '../../../helper';
import accounting from 'accounting-js';
import { VectorMap } from 'react-jvectormap';
import ReactExport from "react-export-excel";
import { matLoader } from '../../../components/Loader';
import { PriceFormatter, dynamicDateFilters1, monthName1, jsonToParam, paramsToJSON, paramsToJSON1 } from '../../../helper';
import swal from 'sweetalert';
import Select from 'react-select';
import { SizePerPageDropDown, sizePerPageList, sizePerPage } from 'react-bootstrap-table';
import cloneDeep from 'lodash/cloneDeep';
import { stat } from 'fs';

const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
        Showing { from} to { to} of { size} Results
    </span>
);

class Opportunity extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedFilterPeriod: "YTD",
            buttonOptionsPeriod: ["MTH", "YTD", "QTR"],
            showQuarter: false,
            dataval: [],
            items: [],
            selectedYear: new Date().getFullYear(),
            selectedItem: new Date().getMonth(),
            showPopUpBoxState: false,
            selectedCheckboxes:[],
            parentVendorName: '',
            isLoading: true,
            showAllOutvendorFeedbackModal: false,
            params: {
                period: "YTD",
                ytd: "true",
                qtr: "false",
                mth: "false",
                year: 2022,
                month: 12,
                quarter: 1,
                buyingGroupId: 0,
                region: "",
                outVendor: "",
                vendorDisplayName: "",
            },
            showFeedbackModal: false,
            showLPGVendorSelect: false,
            displayModal: false,
            res:'',
            propsForModal: {

            },
            classigicationFlag: [
                { flag: 'IN', text: 'IN IMARK SUPPLIER' },
                { flag: 'BUYSELL', text: 'BUYSELL REP SUPPLIER' },
                { flag: 'LPG', text: 'LPG SUPPLIER' },
                { flag: 'PARENT', text: 'Map to existing Out Supplier' },
                { flag: 'EXCLUDE', text: 'No Competitive IMARK Supplier' },
                { flag: 'NP', text: 'Non Plumbing Supplier' },
                { flag: 'MEMBER_COMPANY', text: 'Purchase from Member Company' },
                { flag: 'BRANCH_COMPANY', text: 'Purchase from Own Branch Company' },
                { flag: 'DIFF_BUYING_GROUP', text: 'Rebates Run Through Another Buying Group' }

            ],

        }
        this.vectorMapRef = React.createRef();
    }
    handleUserSelectedFilter(option) {
        let obj = {};

        if (option === "qtr" || option === "QTR") {
            this.setState({ showQuarter: true });
        } else {
            this.setState({ showQuarter: false });
        }

        let paramsValues = this.state.params;
        let paramsfinal = paramsToJSON1(paramsValues);
        let month = paramsfinal.month;
        if (month >= 1 && month <= 3) {
            paramsfinal.quarter = 1
        }
        else if (month >= 4 && month <= 6) {
            paramsfinal.quarter = 2
        }
        else if (month >= 7 && month <= 9) {
            paramsfinal.quarter = 3
        }
        else if (month >= 10 && month <= 12) {
            paramsfinal.quarter = 4
        }

        let params = jsonToParam(paramsfinal);
        this.setState({ selectedFilterPeriod: option, params: params }, () => {
            this.setFilter({ period: this.state.selectedFilterPeriod, year: this.state.year, quarter: this.state.quarter, month: this.state.month, memberId: this.props.memberId });
        });

    }
    componentWillMount() {

        let paramsValues = this.state.params;
        let paramsfinal = dynamicDateFilters1(paramsValues);
        let params = jsonToParam(paramsfinal);

        console.log(params);
        this.setState({ params: params });

    }

    componentDidMount() {
        console.log('filters ', this.props.showMonth == "false");
        console.log(this.state.showQuarter);
        if (this.props.showMonth == "false" && this.state.showQuarter === false) {
            this.setState({ showQuarter: false, buttonOptionsPeriod: ["YTD", "QTR"], selectedFilterPeriod: "YTD" });
        }
        Promise.all([
            this.props.getStateRegionsAPI(),
            this.props.tabTrackingAPI("tabId=13"),
            // this.props.getOpportunitiesCardsAPI(this.state.params),
            // this.props.getSalesRebateOpportunitiesTrendAPI(this.state.params),
            // this.props.getOpportunitiesByRegionAPI(this.state.params),
            // this.props.getOpportunitiesUnapprovedSupplierVolumeByMemberAPI(this.state.params),
            // this.props.getOpportunitiesVendorPartnerVolumeAPI(this.state.params),
            // this.props.getOpportunitiesUnapprovedProductGroupAPI(this.state.params),
            // this.props.getTerminatedVPNamesForCorporateAPI(this.state.params),
            // this.props.getStateToStateMappingAPI(),
            this.props.getCorporateOpportunityMonthsFilterAPI(this.state.params),
            //this.props.getLPGNamesForMemberAPI(this.state.params),
        ]).then(data => {
            this.getOptions();
            this.getOptionsYear();
            this.setState({
                isLoading: false
            })
        }).catch(err => {

            this.setState({
                isLoading: false
            })
        })
        let checkStorage = localStorage.setItem('flag','11')
        setTimeout(function () { localStorage.removeItem("flag"); }, 5000);
    }
    handleChangeOfDropdown(event) {
        let params = this.state.params;
        params = paramsToJSON1(params);
        let obj = {};
        obj[event.name] = event.value;
        params.quarter = event.value;
        let quarter = params.quarter
        params = jsonToParam(params);
        this.setState({
            quarter: quarter,
            params: params
        })
        this.setState(obj, () => {
            this.setFilter({ period: this.state.selectedFilter, quarter: this.state.quarter });
        });

    }
    handleChangeOfDropdownMonth = (e) => {

        let params = this.state.params;
        params = paramsToJSON1(params);
        let month = ''
        params.month = e.value
        month = params.month

        let selectedItem = { label: monthName1(month), value: month }
        if (month >= 1 && month <= 3) {
            params.quarter = 1
        }
        else if (month >= 4 && month <= 6) {
            params.quarter = 2
        }
        else if (month >= 7 && month <= 9) {
            params.quarter = 3
        }
        else if (month >= 10 && month <= 12) {
            params.quarter = 4
        }
        params = jsonToParam(params);
        this.setState({
            params: params,
            selectedItem: selectedItem,

        })

        this.props.getOpportunitiesCardsAPI(params)
        this.props.getSalesRebateOpportunitiesTrendAPI(params)
        this.props.getOpportunitiesByRegionAPI(params)
        this.props.getOpportunitiesUnapprovedSupplierVolumeByMemberAPI(params)
        this.props.getOpportunitiesVendorPartnerVolumeAPI(params)
        this.props.getOpportunitiesUnapprovedProductGroupAPI(params)
        this.props.getTerminatedVPNamesForCorporateAPI(params)
        this.props.getLPGNamesForMemberAPI(params)



    }

    componentWillReceiveProps(props) {
        const { dataForChart1, dataForChart2 } = this.state;
        if (!_isEqual(this.state.dataForChart1, dataForChart1)) {
            this.setState({
                dataForChart1: {
                    data: {
                        columns: [
                            props.getSalesRebateOpportunitiesTrend.chartData11,
                            props.getSalesRebateOpportunitiesTrend.chartData22,
                        ],
                        axes: {
                            data1: 'y',
                            data2: 'y2'
                        },
                    }
                }
            });
        }
        if (!_isEqual(this.state.dataForChart2, dataForChart2)) {
            this.setState({
                dataForChart2: {
                    data: {
                        columns: [
                            props.getSalesRebateOpportunitiesTrend.chartData1,
                            props.getSalesRebateOpportunitiesTrend.chartData2,
                        ],
                        axes: {
                            data1: 'y',
                            data2: 'y2'
                        },
                    }
                }
            });
        }
    }
    setFilter = (filter) => {
        console.log(filter);
        let params = this.state.params;
        params = paramsToJSON(params);
        if (filter.period === "qtr" || filter.period == "QTR") {
            params.qtr = "true";
            params.mth = "false";
            params.ytd = "false";
            // params.quarter = filter.quarter;
            // params.year = filter.year;
            params.period = filter.period;
        } else if (filter.period === "MTH" || filter.period == "mth") {

            params.qtr = "false";
            params.mth = "true";
            params.ytd = "false";
            // params.month = filter.month;
            // params.year = filter.year;
            params.period = filter.period;
        } else if (filter.period === "YTD" || filter.period == "ytd") {
            params.qtr = "false";
            params.mth = "false";
            params.ytd = "true";
            // params.year = filter.year;
            // params.month = filter.month;
            params.period = filter.period;
        }
        else if (filter.year != undefined) {
            params.year = filter.year;

        }
        else if (filter.month != undefined) {
            params.month = filter.month;

        }
        else if (filter.quarter != undefined) {
            params.quarter = filter.quarter;

        }
        else if (filter.buyingGroupId != undefined) {
            params.buyingGroupId = filter.buyingGroupId;

        }
        else if (filter.buyingGroupId == undefined) {
            params.buyingGroupId = params.buyingGroupId;

        }
        params = jsonToParam(params);
        this.setState({
            params: params,
            refreshData: true,
            isLoading: true
        }, () => Promise.all([
            this.props.getSalesRebateOpportunitiesTrendAPI(this.state.params),
            // this.props.getOpportunitiesRebateVsRebateOppAPI(this.state.params),
            this.props.getOpportunitiesByRegionAPI(this.state.params),
            this.props.getOpportunitiesUnapprovedSupplierVolumeByMemberAPI(this.state.params),
            this.props.getOpportunitiesVendorPartnerVolumeAPI(this.state.params),
            this.props.getOpportunitiesUnapprovedProductGroupAPI(this.state.params),
            this.props.getOpportunitiesCardsAPI(this.state.params),
            this.props.getTerminatedVPNamesForCorporateAPI(this.state.params),
            this.props.getLPGNamesForMemberAPI(this.state.params)

        ]).then(data => {

            this.setState({
                isLoading: false
            })
        }).catch(err => {

            this.setState({
                isLoading: false
            })
        }))

    }
    handleChangeOfDropdownYear(e) {
        let params = this.state.params;
        params = paramsToJSON1(params);
        let year = ''
        let items =[]
        params.year = e.value
        year = params.year
        let selectedYear=  {label: year , value :year}
        let dataval = Object.keys(this.props.getCorporateOpportunityMonthsFilter);
        let yearval = dataval.map((val) => {
            return {
                label: val,
                value: val,
            }
        })

        let selectedYear1 = yearval[yearval.length - 1];
        // if (selectedYear1.value != 2023 && e.value == 2023 )
        if (selectedYear1.value != 2024 && e.value == 2024 )
        {
            items = [{ label: monthName1(1),value: 1}];
        }
        else {
        let dataval1 = Object.values(this.props.getCorporateOpportunityMonthsFilter[year]);
        if(typeof dataval1 == 'undefined')
            {
              items = [{ label: monthName1(1),value: 1}];
          
            }
            else{
              items = dataval1.map(itemval => {
                  return {
                      label: monthName1(itemval),
                      value: itemval,
                  }
      
              })
          }
        }
        
        let selectedItem = items[items.length - 1];
        params.month = selectedItem.value;
        let month = selectedItem.value;
        if (month >= 1 && month <= 3) {
            params.quarter = 1
        }
        else if (month >= 4 && month <= 6) {
            params.quarter = 2
        }
        else if (month >= 7 && month <= 9) {
            params.quarter = 3
        }
        else if (month >= 10 && month <= 12) {
            params.quarter = 4
        }
        params = jsonToParam(params);
        this.setState({
            params: params,
            selectedYear: selectedYear,
            items: items,
            selectedItem : selectedItem,
    })
    this.setState(e, () => {
        this.setFilter({ year: this.state.year, selectedYear: selectedYear,selectedItem:selectedItem });
    });

        // let params = this.state.params;
        // params = paramsToJSON1(params);
        // let year = ''
        // params.year = e.value
        // year = params.year
        // let selectedYear = { label: year, value: year }

        // params = jsonToParam(params);
        // this.setState({
        //     params: params,
        //     selectedYear: selectedYear,
        // }, this.getOptions)

        // console.log(this.state.selectedYear);


    }
    getOptionsYear() {
        let dataval = Object.keys(this.props.getCorporateOpportunityMonthsFilter);
        let yearval = dataval.map((val) => {
            return {
                label: val,
                value: val,
            }
        })
        let selectedYear = yearval[yearval.length - 1];
        // if (selectedYear.value != 2021 && selectedYear.value != 2022 && selectedYear.value != 2023)
        if (selectedYear.value != 2021 && selectedYear.value != 2022 && selectedYear.value != 2023 && selectedYear.value != 2024)
        {
        yearval.push({ label: 2021, value: 2021 });
        yearval.push({ label: 2022, value: 2022 });
        yearval.push({ label: 2023, value: 2023 });
        yearval.push({ label: 2024, value: 2024 });
        }
        else if (selectedYear.value != 2023 && selectedYear.value != 2024){
        // else if (selectedYear.value != 2023 && selectedYear.value == 2022){
            yearval.push({ label: 2023, value: 2023 });
            yearval.push({ label: 2024, value: 2024 });
        }
        
        //add this new code
        else if (selectedYear.value != 2024){
            yearval.push({ label: 2024, value: 2024 });
  
        }
        // params = jsonToParam(params);
        this.setState({
            selectedYear: selectedYear,
            yearval: yearval,
            // params: params ,
        })
    }
    getOptions() {

        let params = this.state.params;
        params = paramsToJSON(params);
        let items = []
        // items = this.props.getCorporateOpportunityMonthsFilter[params.year].map(itemval => {
        //     return {
        //         label: monthName1(itemval),
        //         value: itemval,
        //     }

        // }) 
        let dataval = Object.keys(this.props.getCorporateOpportunityMonthsFilter);
        let yearval = dataval.map((val) => {
            return {
                label: val,
                value: val,
            }
        })
        let selectedYear1 = yearval[yearval.length - 1];

        let dataval1 = Object.values(this.props.getCorporateOpportunityMonthsFilter[selectedYear1.value]);
        if(typeof dataval1 == 'undefined')
            {
              items = [{ label: monthName1(1),value: 1}];
          
            }
            else{
              items = dataval1.map(itemval => {
                  return {
                      label: monthName1(itemval),
                      value: itemval,
                  }
      
              })
          }

        if (selectedYear1.value != 2022)
        {
        yearval.push({ label: 2022, value: 2022 });
        }
        let selectedItem = items[items.length - 1];
        params.month = selectedItem.value;
        params.year = selectedYear1.value;
        let month = selectedItem.value;
        if (month >= 1 && month <= 3) {
            params.quarter = 1
        }
        else if (month >= 4 && month <= 6) {
            params.quarter = 2
        }
        else if (month >= 7 && month <= 9) {
            params.quarter = 3
        }
        else if (month >= 10 && month <= 12) {
            params.quarter = 4
        }
        params = jsonToParam(params);
        this.setState({
            items: items,
            selectedItem: selectedItem,
            params: params,
        })
        this.props.getSalesRebateOpportunitiesTrendAPI(params)
        this.props.getOpportunitiesByRegionAPI(params)
        this.props.getOpportunitiesUnapprovedSupplierVolumeByMemberAPI(params)
        this.props.getOpportunitiesVendorPartnerVolumeAPI(params)
        this.props.getOpportunitiesUnapprovedProductGroupAPI(params)
        this.props.getOpportunitiesCardsAPI(params)
        this.props.getTerminatedVPNamesForCorporateAPI(params)
        this.props.getLPGNamesForMemberAPI(params)
    }

    renderButtonGroup() {

        return this.state.buttonOptionsPeriod.map((option, index) => {
            return (
                <button style={{ height: '38px' }} key={index} type="button" value={option}
                    onClick={(e) => { console.log(e.target.value); this.handleUserSelectedFilter(e.target.value) }}
                    class={`btn btn-light ${(this.state.selectedFilterPeriod === option) ? "active" : null}`}>{option}</button>
            )
        })
    }
    closeModal = () => {
        this.setState({ displayModal: false });
    }
    displayModal() {
        if (this.state.displayModal === true) {
            // render table or card according to modaltype

            return (
                <Modal parentView="CategoyDetails" modalType="table" width="400px" propsForModal={this.state.propsForModal} closeModal={this.closeModal} />
            )
        } else {
            return (
                <div className="modal fade" tabIndex="-1" role="dialog">

                </div>
            )
        }
    }

    overTriggerToolTip(tableName, columnName) {
        return (
          <OverlayTrigger
            placement='top'
            overlay={'hiii'}
          >
            <span>{columnName}</span>
          </OverlayTrigger>
        );
      }
    baropportunityUnapprovedSuppVolumeByMemberData = (cell, row) => {
        //   ;
        // this.corporateOverviewVPPerformance =[];
        this.opportunityUnapprovedSuppVolumeByMemberData.push(row.rebateOpportunity)
        let max = Math.max(...this.props.MemberList);
        let str = accounting.formatMoney(cell);
        str = str.slice(0, -3);
        return (
            <React.Fragment>
                <OverlayTrigger overlay={(<Tooltip> Rebate Opportunity {PriceFormatter(row.rebateOpportunity)}</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="top">

                    <div className="progress">

                        <div className="progress-bar" role="progressbar"
                            aria-valuemin="0" style={{ width: (cell / max) * 100 }}>
                        </div>
                    </div>
                </OverlayTrigger>
            </React.Fragment>

        )
    }
    baropportunitiesUnapprovedProductGroup = (cell, row) => {
        //;

        this.opportunitiesUnapprovedProductGroup.push(row.rebateOpportunity)
        let max = Math.max(...this.props.PGList);
        let str = accounting.formatMoney(cell);
        str = str.slice(0, -3);
        return (
            <React.Fragment>
                <OverlayTrigger overlay={(<Tooltip> Rebate Opportunity {PriceFormatter(row.rebateOpportunity)}</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="top">

                    <div className="progress">

                        <div className="progress-bar" role="progressbar"
                            aria-valuemin="0" style={{ width: (cell / max) * 100 }}>
                        </div>
                    </div>
                </OverlayTrigger>
            </React.Fragment>

        )
    }
    baropportunityVendorPartnerVolumeData = (cell, row) => {
        //;

        this.opportunityVendorPartnerVolumeData.push(row.rebateOpportunity)
        let max = Math.max(...this.props.VolumeList);
        let str = accounting.formatMoney(cell);
        str = str.slice(0, -3);
        return (
            <React.Fragment>
                <OverlayTrigger overlay={(<Tooltip> Rebate Opportunity {PriceFormatter(row.rebateOpportunity)}</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="top">

                    <div className="progress">

                        <div className="progress-bar" role="progressbar"
                            aria-valuemin="0" style={{ width: (cell / max) * 100 }}>
                        </div>
                    </div>
                </OverlayTrigger>

            </React.Fragment>

        )
    }

    renderVectorMap() {
        const { opportunitiesByRegion } = this.props;
        const { stateRegionMapping } = this.props;
        let regionDetails = {};
        if (!_isEmpty(opportunitiesByRegion)) {
            opportunitiesByRegion.map((missedAmount) => {
                let state = missedAmount.region.toLowerCase();
                let region = stateRegionMapping[state];                
                //make region name as key, and as value keep an object that has info like sum and count
                let obj = {};
                if (regionDetails.hasOwnProperty(region)) {

                    let valueOfState = missedAmount.missedAmount;
                    let previousSumValue = regionDetails[region].sum;
                    let previousCountValue = regionDetails[region].count;
                    obj = {
                        sum: valueOfState + previousSumValue,
                        count: previousCountValue + 1,
                    }
                    regionDetails[region] = obj;
                } else {

                    let valueOfState = missedAmount.missedAmount;
                    obj = {
                        sum: valueOfState,
                        count: 1
                    }
                    regionDetails[region] = obj;
                }
            });
        }

        //now iterate over all objects, and add a field called average
        Object.keys(regionDetails).forEach(function (key) {
            let average = regionDetails[key].sum / regionDetails[key].count;
            average = average.toFixed(2);
            regionDetails[key].average = average;
        })

        let objForMap = {};
        //new approach
        // iterate over stateregionmapping, get state, find region, get value, assign it to obj
        Object.keys(stateRegionMapping).forEach(function (key) {
            let state = key;
            //find region
            let region = stateRegionMapping[key];
            //check if data exists
            if (regionDetails.hasOwnProperty(region)) {
                let regionVal = regionDetails[region].average;
                objForMap["US-" + key.toUpperCase()] = regionVal;
            } else {

                objForMap["US-" + key.toUpperCase()] = 0;
            }
        });

        const series = {
            regions: [{
                values: objForMap,
                scale: ['#FEE5D9', '#A50F15'],
                normalizeFunction: 'polynomial',

            }]
        }
        return (
            <VectorMap map={'us_aea'}
                // ref={this.vectorMapRef}
                backgroundColor="transparent"
                series={series}
                ref="map"
                containerStyle={{
                    width: '100% !important;',
                    height: '100% !important;',
                    // overflow:'hidden',
                    // resizeMode: 'cover',
                }}
                regionsSelectable="true"
                selectedRegions={this.state.selectedStates}
                regionStyle={{
                    initial: {
                        fill: "#0000FF",
                        "fill-opacity": 0.9,
                        stroke: "none",
                        "stroke-width": 0,
                        "stroke-opacity": 0
                    },
                    hover: {
                        "fill-opacity": 0.8,
                        cursor: "pointer"
                    },
                    selected: {
                        fill: "rgb(43, 142, 187)"
                    },
                    selectedHover: {},
                    containerStyle: {
                        width: '100% !important;',
                        height: '100% !important;',
                        // resizeMode: 'cover',
                        // overflow:'hidden',
                    },
                }}
                onRegionTipShow={(e, el, code) => this.handleMouseEvent(e, el, objForMap[code])}
                onRegionClick={(e, el, code) => this.handleRegionClick(e, el, code)}
                containerStyle={{
                    width: '530px',
                    height: '450px',
                    marginLeft: '15px',
                    //                     resizeMode: 'cover',
                    //                     overflow:'hidden',
                    //                     display: 'flex',
                    // flexdirection: 'row',
                }}
            />

        )
    }
    hideRegionTip() {
        let arr = document.getElementsByClassName('jvectormap-tip');

        for (let i = 0; i < arr.length; i++) {
            arr[i].style.display = "";
        }

    }
    handleRegionClick(e, el, code) {
        //;
        let params = this.state.params;
        params = paramsToJSON(params);
        const { stateRegionMapping } = this.props;
        let stateSelectedTrimmed = el.substring(3).toLowerCase();
        let regionSelected = stateRegionMapping[stateSelectedTrimmed];
        let statesToBeSelected = [];
        Object.keys(stateRegionMapping).forEach(function (key, index) {
            if (stateRegionMapping[key] === regionSelected) {
                let modifiedName = "US-" + key;
                modifiedName = modifiedName.toUpperCase();
                statesToBeSelected.push(modifiedName);
            }
        })
        //;
        params.region = regionSelected;
        this.setState({ params: jsonToParam(params), selectedStates: statesToBeSelected }, () => {
            this.props.getOpportunitiesUnapprovedSupplierVolumeByMemberAPI(this.state.params);
            this.props.getOpportunitiesUnapprovedProductGroupAPI(this.state.params);
            this.props.getOpportunitiesVendorPartnerVolumeAPI(this.state.params);
        });
        this.refs.map.$mapObject.tip.hide();
    }

    handleMouseEvent(e, el, salesObj) {

        const { stateRegionMapping, stateToStateMapping } = this.props;
        let stateForRegionMapping = stateToStateMapping[el.html()];
        let region = stateRegionMapping[stateForRegionMapping];
        if (salesObj) {
            el.html(el.html() + "<div>" + regionCodeNameMapping[region] + "</div><hr><div>Sales Opportunity</div>" + accounting.formatMoney(salesObj))
        } else {
            el.html("<div>" + region + "</div><hr><div>" + el.html() + "</div>");
        }      

    }

    showFeedback = (cell, row) => {
        return (
            <div onClick={(e) => { this.setState({ showPopUpBoxState: true, selectedUnapprovedSupplier: row.vendorName }); }}>   <i className="fas fa-comment"></i></div>
        )
    }

    closeModal = () => {
        this.setState({ showPopUpBoxState: false });
    }

    sendUnapprovedSupplierFeedback() {

        let selections = {
            source: "CORPORATE",
            unapprovedSupplierId: null,
            unapprovedSupplierName: this.state.selectedUnapprovedSupplier,
            supplierType: "PARENT",
            suggestedSupplierId: null,
            suggestedSupplierName: this.state.parentVendorName,
            comments: '',
            supplier: '',
        }
        this.props.insertFeedbackUnapprovedSupplierFeedbackAPI(selections, (res) => {
            this.setState({ showPopUpBoxState: false }, () => {
                toast(res.data.message);
            });

        });
    }
    showFeedbackModal = (row) => {
        //;
        this.setState({ vendorDisplayName: row.vendorName, showFeedbackModal: true });
    }
    // Out Supplier Feedback 
    closeFeedbackModal = () => {
        this.setState({ showFeedbackModal: false, showSugestedVendorSelect: false, showLPGVendorSelect: false });
    }

    showFeedbackIcon = (cell, row) => {
        return (
            <OverlayTrigger overlay={(<Tooltip>Feedback for {row.vendorName}</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="top">

                <Link onClick={(e) => {
                    e.preventDefault();
                    this.showFeedbackModal(row)
                }}> <i className="fas fa-comment-alt"></i></Link>
            </OverlayTrigger>
        )
    }
    handleClick = (e, value) => {
        let arr = [];
        let arr1 = [];
        let valuestr = [value.value];      
        if (valuestr > 0) {
            let valueee = valuestr.map((option, index) => {
                let val = _find(value.options, ['value', option])
                arr.push(val.value)
                arr1.push(val.text)
            })


        }
        this.setState({ suggestedVendorId: encodeURIComponent(arr), suggestedVendorName: encodeURIComponent(arr1) })

    }
    handleFlagChange = classification => {
        //  ;
        console.debug('Selected Flag', classification);
        this.setState(classification.flag === 'PARENT' ? {
            showSugestedVendorSelect: false,
            showVendorNameInput: true,
            showLPGVendorSelect: false,
        } : this.setState(classification.flag === 'NP' ? {
            showSugestedVendorSelect: false,
            showVendorNameInput: false,
            showLPGVendorSelect: false,
        }:
            this.setState(classification.flag === 'MEMBER_COMPANY' ? {
                showSugestedVendorSelect: false,
                showVendorNameInput: false,
                showLPGVendorSelect: false,
            } :
                this.setState(classification.flag === 'BRANCH_COMPANY' ? {
                    showSugestedVendorSelect: false,
                    showVendorNameInput: false,
                    showLPGVendorSelect: false,
                }:
                this.setState(classification.flag === 'DIFF_BUYING_GROUP' ? {
                    showSugestedVendorSelect: false,
                    showVendorNameInput: false,
                    showLPGVendorSelect: false,
                } :
                    this.setState(classification.flag === 'LPG' ? {
                        showLPGVendorSelect: true,
                        showSugestedVendorSelect: false,
                        showVendorNameInput: false,

                    } : {
                            showSugestedVendorSelect: true,
                            showVendorNameInput: false,
                            showLPGVendorSelect: false,
                        }))))));

        classification = classification.flag
        this.setState({ classificationFlag: classification })

    }

    closeProductListModal = () => {
        this.setState({ showProductListModal: false });
    }
    onRowSelect = (row, isSelected) => {

        let outVendorList = cloneDeep(this.state.selectedCheckboxes);
        if (isSelected) {

            outVendorList.push(row);

            this.setState({ selectedCheckboxes: outVendorList });
        } else {
            let unCheckedCheckBox = outVendorList.filter(
                (item) => item.vendorName !== row.vendorName
            );
            this.setState({ selectedCheckboxes: unCheckedCheckBox });
        }

    };
    onSelectAll = (isSelected, rows) => {
        let outVendorList = cloneDeep(this.state.selectedCheckboxes);
        if (isSelected) {
            rows.map((item) => {
                outVendorList.push(item);
            });
            this.setState({
                selectedCheckboxes: outVendorList,
                checkedCheckBox: true,

            });
        } else {
            this.setState({ selectedCheckboxes: [], checkedCheckBox: false });
        }
    };

    submitForm = row => {
        let selections = {
            vendorDisplayName: this.state.vendorDisplayName,
            classificationFlag: this.state.classificationFlag,
            suggestedVendorId: this.state.suggestedVendorId,
            suggestedVendorName: this.state.suggestedVendorName,
            feedbackComments: this.state.feedbackComments,

        }
        // if (!this.state.suggestedVendorName) {
        //     this.setState({ ErrorMessage: 'Please select a supplier partner' }, () => {
        //     });
        // } else {
        //     this.setState({ showFeedbackModal: false, showSugestedVendorSelect: false, showLPGVendorSelect: false, showVendorNameInput: false, ErrorMessage: '' }, () => {
        //         this.props.saveOutVendorFeedbackAPI(selections, (res) => {
        //             // console.log("Response",res);
        //             toast(res.data.text);
        //             this.refs.vendorname.value = '';
        //             this.refs.vendorname1.value = '';
        //         });

        //     });
        // }
        if (this.state.classificationFlag != "MEMBER_COMPANY" &&
        this.state.classificationFlag != "BRANCH_COMPANY" && this.state.classificationFlag != "NP"  && this.state.classificationFlag != "DIFF_BUYING_GROUP") {

        if (!this.state.suggestedVendorName) {
            this.setState({ ErrorMessage: 'Please select a supplier partner' }, () => {
            });
        } else {
            
            this.setState({ showFeedbackModal:false,suggestedVendorName: '', showLPGVendorSelect: '', showSugestedVendorSelect: '', ErrorMessage: '' }, () => {
                this.props.saveOutVendorFeedbackAPI(selections, (res) => {
                    toast(res.data.text);
                    this.refs.vendorname.value = '';
                    this.refs.vendordropdown.value = '';
                });

            });
        }
    }
    else {
        this.setState({ suggestedVendorName: '', showSugestedVendorSelect: '', showLPGVendorSelect: '', ErrorMessage: '' }, () => {
            this.props.saveOutVendorFeedbackAPI(selections, (res) => {
                toast(res.data.text);
                this.refs.vendorname.value = '';
                this.refs.vendordropdown.value = '';
            });

        });

    }
    }
    AllFeedbackButtonFunction = (data) => {
        return this.setState({ showAllOutvendorFeedbackModal: true });
    };
    closeAllFeedbackModal = () => {
        this.setState({
            showAllOutvendorFeedbackModal: false,selectedCheckboxes:[]
        });
    }
    submitFormAll = row => {
        this.state.selectedCheckboxes.map((feedbackList) => {

            let selections = {
                vendorDisplayName: feedbackList.vendorName,
                classificationFlag: this.state.classificationFlag,
                suggestedVendorId: this.state.suggestedVendorId,
                suggestedVendorName: this.state.suggestedVendorName,
                feedbackComments: this.state.feedbackComments,

            }
            if (!this.state.suggestedVendorName) {
                this.setState({ ErrorMessage: 'Please select a supplier partner' }, () => {
                });
            } else {
               
                    this.props.saveOutVendorFeedbackAPI(selections, (res) => {
                        this.setState({
                            showAllOutvendorFeedbackModal: false,
                            showSugestedVendorSelect: false, showLPGVendorSelect: false,
                            showVendorNameInput: false, ErrorMessage: '', 
                            res: res.data.text,
                        });
                        this.refs.vendorname.value = '';
                        this.refs.vendorname1.value = '';
                    });
                   
            }
        
          
        });
        toast(this.state.res,2000);
        
    }
    // renderPaginationPanel = (props) => {
    //     return (
    //       <div>
    //         <div>{ props.components.pageList }</div>
    //         <div>
    //           <span>Change size per page: </span>
    //           { props.components.sizePerPageDropdown }
    //         </div>
    //         <div>
    //           <button onClick={ () => props.changeSizePerPage(25) } className='btn btn-default'>Click to force size per page as 25</button>
    //           <button onClick={ () => props.toggleDropDown() } className='btn btn-default'>Click to force toggle dropdown</button>
    //           {/* <button onClick={ () => props.changePage(3) } className='btn btn-default'>Jump to page 3</button> */}
    //         </div>
    //       </div>
    //     );
    //   }
    //
    getVolumeDefaultData = (onClick) => {
        onClick();
        this.refs.table.cleanSelected();
        this.refs.table1.cleanSelected();
        this.refs.table2.cleanSelected();
        let params = this.state.params;
        params = paramsToJSON(params);
        params.region = "";
        params.outVendor = "";
        params.vendorDisplayName = "";
        params.memberId = '';
        params.vendorId = ''
        params.productGroupId = ''
        params = jsonToParam(params);
        this.setState({ selectedStates: [], params: params })
        this.props.getOpportunitiesVendorPartnerVolumeAPI(params);
        this.props.getOpportunitiesUnapprovedSupplierVolumeByMemberAPI(params);
        this.props.getOpportunitiesUnapprovedProductGroupAPI(params);
        this.props.getOpportunitiesByRegionAPI(params);
        this.refs.table.reset();
        this.refs.table1.reset();
        this.refs.table2.reset();

        //props.searchProps.onClear;

    }
    getMemberDefaultData = (onClick) => {
        onClick();
        this.refs.table.cleanSelected();
        this.refs.table1.cleanSelected();
        this.refs.table2.cleanSelected();
        let params = this.state.params;
        params = paramsToJSON(params);
        params.region = "";
        params.outVendor = "";
        params.vendorDisplayName = "";
        params.productGroupId = '';
        params.memberId = '';
        params.vendorId = '';
        params = jsonToParam(params);
        this.setState({ selectedStates: [], params: params, })
        this.props.getOpportunitiesUnapprovedSupplierVolumeByMemberAPI(params);
        this.props.getOpportunitiesVendorPartnerVolumeAPI(params);
        this.props.getOpportunitiesUnapprovedProductGroupAPI(params);
        this.props.getOpportunitiesByRegionAPI(params);
        this.refs.table.reset();
        this.refs.table1.reset();
        this.refs.table2.reset();
        
    }
    getProductGroupDefaultData = (onClick) => {
        let params = this.state.params;
        params = paramsToJSON(params);
        params.region = "";
        params.outVendor = "";
        params.vendorDisplayName = "";
        params.productGroupId = "";
        params.memberId = "";
        params.vendorId = "";
        params = jsonToParam(params);
        this.setState({ selectedStates: [], params: params, })
        this.props.getOpportunitiesUnapprovedProductGroupAPI(params);
        this.props.getOpportunitiesUnapprovedSupplierVolumeByMemberAPI(params);
        this.props.getOpportunitiesVendorPartnerVolumeAPI(params);
        this.props.getOpportunitiesByRegionAPI(params);
        onClick();
        this.refs.table.reset();
        this.refs.table1.reset();
        this.refs.table2.reset();
        this.refs.table.cleanSelected();
        this.refs.table1.cleanSelected();
        this.refs.table2.cleanSelected();
    }
    onToggleDropDown = (toggleDropDown) => {
        // do your stuff here
        console.log('toggle dropdown');
        toggleDropDown();
    }
    renderSizePerPageDropDown = (props) => {
        return (
            <SizePerPageDropDown
                className='my-size-per-page'
                btnContextual='btn-warning'
                variation='dropup'
                onClick={() => this.onToggleDropDown(props.toggleDropDown)} />
        );
    }
    createCustomClearButtonForMember = (onClick) => {
        return (
            <button
                className='btn btn-primary '
                style={{'height': '24px','font-size': '11px','font-weight': '700',
                'font-stretch': 'extra-expanded'}}
                onClick={(e) => this.getMemberDefaultData(onClick)}
            >
                 Clear All
            </button>
        );
    };
    renderOpportunityByMember() {
        const { opportunityUnapprovedSuppVolumeByMemberData } = this.props;
        this.opportunityUnapprovedSuppVolumeByMemberData = [];
        const options = {
            onRowClick: this.handleRowClickMember,
            sizePerPageDropDown: this.renderSizePerPageDropDown,
            bgColor: "rgb(0,123,255)",
            clearSearch: true,
            clearSearchBtn: this.createCustomClearButtonForMember,
        }

        return (
            <div className="" >
                <div className="card-deck">
                    <div className="card shadow-sm mb-3">

                        {/* <div className="card-header">
                        Purchase Outside IMARK by Member
                         <button className="btn btn-primary" style={{float:"right",}} onClick={this.getMemberDefaultData} > Clear All </button>
                                  
                            </div> */}
                        <div className="card-body" style={{ maxHeight: " 410" }}>
                            <h5 style={{ textDecorationLine: 'underline', }}> Purchase Outside IMARK by Member</h5>
                            {/* <button className="btn btn-primary" style={{ float: "right", marginTop: "2px" }} onClick={this.getMemberDefaultData} > Clear All </button>
                             */}
                            <BootstrapTable options={options} ref='table1' selectRow={this.selectRowProp} height='400' search data={opportunityUnapprovedSuppVolumeByMemberData} pagination striped hover version="4">
                                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} dataSort={true} isKey dataField='memberName'>Member Name </TableHeaderColumn>
                                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} dataSort={true} hidden dataField='memberId'>Member Id </TableHeaderColumn>
                                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} dataSort={true} dataField='city'>City </TableHeaderColumn>
                                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} dataSort={true} dataField='state'>State </TableHeaderColumn>
                                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} dataSort={true} dataFormat={this.baropportunityUnapprovedSuppVolumeByMemberData} dataField='missedOpportunity'>Supplier Rebate</TableHeaderColumn>
                                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} dataFormat={PriceFormatter} dataSort={true} dataField='missedOpportunity'>Missed Opportunity</TableHeaderColumn>
                            </BootstrapTable>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    handleRowClick = row => {
        console.log('handleRowClick')
        let params = this.state.params;
        params = paramsToJSON(params);
        params.vendorDisplayName = row.vendorName;
        params = jsonToParam(params);
        this.props.getOpportunitiesUnapprovedProductGroupAPI(params);
        this.props.getOpportunitiesUnapprovedSupplierVolumeByMemberAPI(params);
        this.props.getOpportunitiesByRegionAPI(params);
    }
    handleRowClickProductGroup = row => {

        let params = this.state.params;
        params = paramsToJSON(params);
        //params.memberId = encodeURIComponent(row.memberId);
        params.productGroupId = encodeURIComponent(row.tierFourId);
        params = jsonToParam(params);
        this.props.getOpportunitiesVendorPartnerVolumeAPI(params)
        this.props.getOpportunitiesByRegionAPI(params);
        this.props.getOpportunitiesUnapprovedSupplierVolumeByMemberAPI(params);
    }
    handleRowClickMember = row => {

        let params = this.state.params;
        params = paramsToJSON(params);
        params.memberId = encodeURIComponent(row.memberId);
        // params.productGroupId = encodeURIComponent(row.tierFourId);
        params = jsonToParam(params);
        this.props.getOpportunitiesByRegionAPI(params);
        this.props.getOpportunitiesVendorPartnerVolumeAPI(params)
        this.props.getOpportunitiesUnapprovedProductGroupAPI(params);

    }
    renderSizePerPageDropDown = props => {
        return (
            <div className='btn-group'>
                {
                    [25, 50, 100].map((n, idx) => {
                        const isActive = (n === props.currSizePerPage) ? 'active' : null;
                        return (
                            <button key={idx} type='button' className={`btn btn-info ${isActive}`} onClick={() => props.changeSizePerPage(n)}>{n}</button>
                        );
                    })
                }
            </div>
        );
    }
    // selectRow. hideSelectColumn 
    selectRowProp = {
        mode: "radio",
        hideSelectColumn: true,
        clickToSelect: true,
        hideSelectAll: true,
        bgColor: "rgb(0,123,255)",
    };

    selectRowProp1 = {
        mode: 'checkbox',
        //bgColor: "rgb(0,123,255)",
        onSelect: this.onRowSelect,
        onSelectAll: this.onSelectAll,
        clickToSelect: false,
        //checkedCheckBox: false,
        hideSelectColumn: false,
        hideSelectAll: false,

    };

    OutVendorName = (cell, rows) => {
        let tier = _get(rows, 'vendorName', "")
        let vendorName = tier;
        if (vendorName) {
            return <div className="vendorName" style={{ textTransform: 'capitalize' }}>{vendorName}</div>
        }
    }

    createCustomClearButtonForVendor = (onClick) => {
        return (
            <button
                className='btn btn-primary '
                style={{'height': '24px','font-size': '11px','font-weight': '700',
                'font-stretch': 'extra-expanded'}}
                onClick={(e) => this.getVolumeDefaultData(onClick)}
            >
            Clear All
            </button>
        );
    };


    renderOpportunityByOutVendors() {
        const { opportunityVendorPartnerVolumeData } = this.props;
        this.opportunityVendorPartnerVolumeData = [];
        const options = {
            onRowClick: this.handleRowClick,
            sizePerPageDropDown: this.renderSizePerPageDropDown,
            bgColor: "rgb(0,123,255)",
            clearSearch: true,
            clearSearchBtn: this.createCustomClearButtonForVendor,
            // hideSelectColumn: true,
            // clickToSelect: true,
            // hideSelectAll: true,
            // paginationShowsTotal: this.renderPaginationShowsTotal,
            // sizePerPage: 100,
            // // paginationShowsTotal: true ,

        }

        return (
            <div className="" >
                <div className="card-deck">
                    <div className="card shadow-sm mb-3">

                        {/* <div className="card-header">
                        Purchase from Supplier outside IMARK
                         <button className="btn btn-primary" style={{float:"right",}} onClick={this.getVolumeDefaultData} > Clear All </button>
                                  
                            </div> */}

                        <div className="card-body" style={{ maxHeight: " 356" }}>
                            <h5 style={{ textDecorationLine: 'underline', }}> Purchase from Supplier outside IMARK</h5>
                            {/* <button className="btn btn-primary" style={{ float: "right", marginTop: "2px" }} onClick={this.getVolumeDefaultData} > Clear All </button> */}

                            {/* selectRow={this.selectRowProp} */}
                            <BootstrapTable options={options} id="rowClick" selectRow={this.selectRowProp1} ref='table2' search height='350' data={opportunityVendorPartnerVolumeData} striped pagination hover version="4" >
                                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} width="100" thStyle={{ whiteSpace: 'normal' }} dataSort={true} isKey dataFormat={this.OutVendorName} dataField='vendorName'> Out Supplier </TableHeaderColumn>
                                <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width="100" dataSort={true} dataFormat={this.baropportunityVendorPartnerVolumeData} dataField='rebateOpportunity'>Supplier Rebate</TableHeaderColumn>
                                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} width="150" thStyle={{ whiteSpace: 'normal' }} dataFormat={PriceFormatter} dataSort={true} dataField='missedOpportunity'>Missed Opportunity</TableHeaderColumn>
                                <TableHeaderColumn dataFormat={this.showFeedbackIcon} width="70" dataField='feedback'> Feedback</TableHeaderColumn>
                            </BootstrapTable>
                        </div>

                        <div className="modal-footer">
                            {this.state.selectedCheckboxes.length >= 1 ? (
                                <div class='form-inline' style={{ justifyContent: 'center' }} >
                                    <button type="button" className="btn btn-primary"
                                        onClick={() => { this.AllFeedbackButtonFunction(this.state.selectedCheckboxes); }}>
                                        Feedback for All Selected Product
                        </button>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    renderPaginationShowsTotal(start, to, total) {
        return (
            <p style={{ color: '' }}>
                Showing rows { start} to { to}
            </p>
        );
    }
    createCustomClearButtonForProductGroup = (onClick) => {
        return (
            <button
                className='btn btn-primary '
                style={{'height': '24px','font-size': '11px','font-weight': '700',
                'font-stretch': 'extra-expanded'}}
                onClick={(e) => this.getProductGroupDefaultData(onClick)}
            >
                 Clear All
            </button>
        );
    };

    renderOpportunityByProductGroup() {
        const { opportunitiesUnapprovedProductGroup } = this.props;
        this.opportunitiesUnapprovedProductGroup = [];
        const options = {
            onRowClick: this.handleRowClickProductGroup,
            sizePerPageDropDown: this.renderSizePerPageDropDown,
            clearSearchBtn: this.createCustomClearButtonForProductGroup,
            bgColor: "rgb(0,123,255)",
            clearSearch: true,
            // paginationShowsTotal: this.renderPaginationShowsTotal,

            // sizePerPage: 100,
            // paginationShowsTotal: true ,

        }
        return (
            <div className="" >
                <div className="card-deck">
                    <div className="card shadow-sm mb-3">
                        <div className="card-body" style={{ maxHeight: " 356" }}>
                            <h5 style={{ textDecorationLine: 'underline', }}> Missed Opportunity by Product Group</h5>
                            {/* <button className="btn btn-primary" style={{ float: "right", marginTop: "2px" }} onClick={this.getProductGroupDefaultData} > Clear All </button> */}


                            <BootstrapTable options={options} ref='table' selectRow={this.selectRowProp} height='350' search data={opportunitiesUnapprovedProductGroup} pagination striped hover version="4">
                                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} dataSort={true} isKey dataField='tierFour'>Product Category </TableHeaderColumn>
                                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} dataSort={true} hidden dataField='tierFourId'> </TableHeaderColumn>
                                <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} dataFormat={PriceFormatter} dataSort={true} dataFormat={this.baropportunitiesUnapprovedProductGroup} dataField='rebateOpportunity'>Supplier Rebate</TableHeaderColumn>
                                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} dataFormat={PriceFormatter} dataSort={true} dataField='missedOpportunity'>Missed Opportunity</TableHeaderColumn>

                            </BootstrapTable>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    handleChangeOfDropdownextra(event) {
        let obj = {};
        obj[event.name] = event.value;
        this.setState(obj, () => {

            //params= paramsToJSON(params);
            this.setFilter({ buyingGroupId: this.state.buyingGroupId });
            //params= jsonToParam(params);
        });
    }

    render() {
        const { unapprovedSupplierPurchasesColumns, unapprovedSupplierPurchasesRows, unapprovedSupplierPurchasesColumnWidths, cardInfo, purchaseOutsideBhByMemberColumnWidths, purchaseOutsideBhByMemberColumns, purchaseOutsideBhByMemberRows,
            purchasefromVendorOutsideBhColumnWidths, purchasefromVendorOutsideBhColumns, purchasefromVendorOutsideBhRows, missedOpportunityByProductGroupColumnWidths, missedOpportunityByProductGroupColumns
            , missedOpportunityByProductGroupRows } = this.state;
        const ExcelFile = ReactExport.ExcelFile;
        const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
        const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
        const { opportunityCardsData, opportunityUnapprovedSuppVolumeByMemberData, opportunityVendorPartnerVolumeData, opportunityUnapprovedSuppVolumeData, opportunityMissedOppByCategory } = this.props;

        let dataForChart1 = {
            data: {
                x: 'x',

                columns: [

                    ['x', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],

                    this.props.getSalesRebateOpportunitiesTrend.chartData11,
                    this.props.getSalesRebateOpportunitiesTrend.chartData22,

                ],
                type: 'bar',
                types: {
                    data1: 'bar',
                    data2: 'line',
                },
                axes: {
                    data1: 'y',
                    data2: 'y2'
                },
                names: {
                    data1: "Sales ($)",
                    data2: "Sales Opportunity ($)"
                }
            },
            axis: {
                x: {
                    type: 'category',
                    // label: 'Month'

                },
                y: {
                    // label: 'TotalMemberSales ',
                    show: true,
                    tick: {
                        format: function (d) { let formatted = accounting.formatMoney(d); return formatted.substring(0, formatted.length - 3) }
                        //                format: function (d) { return "$" + d; }
                    }
                },
                y2: {
                    // label: 'SalesOpportunity',
                    // show: true,
                    tick: {
                        format: function (d) { let formatted = accounting.formatMoney(d); return formatted.substring(0, formatted.length - 3) }
                        //                format: function (d) { return "$" + d; }
                    }
                }
            }
        }
        let dataForChart2 = {
            data: {
                x: 'x',

                columns: [

                    ['x', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],

                    this.props.getSalesRebateOpportunitiesTrend.chartData1,
                    this.props.getSalesRebateOpportunitiesTrend.chartData2,

                ],
                type: 'bar',
                types: {
                    data3: 'bar',
                    data4: 'line',
                },
                axes: {
                    data3: 'y',
                    data4: 'y2'
                },
                names: {
                    data3: "Rebate ($) ",
                    data4: "Rebate Opportunity ($)"
                }
            },
            axis: {
                x: {
                    type: 'category',
                    // label: "Month"
                },
                y: {
                    // label: 'TotalRebate',
                    show: true,
                    tick: {
                        format: function (d) { let formatted = accounting.formatMoney(d); return formatted.substring(0, formatted.length - 3) }
                        //                format: function (d) { return "$" + d; }
                    }
                },
                y2: {
                    // label: 'Rebate Opportunity',
                    // show: true,
                    tick: {
                        format: function (d) { let formatted = accounting.formatMoney(d); return formatted.substring(0, formatted.length - 3) }
                        //                format: function (d) { return "$" + d; }
                    }
                }
            }
        }
        const { showQuarter } = this.state;
        const { monthName } = this.props;
        let cardSection = [];
        opportunityCardsData.map((card, index) => {
            let str3 = card.value;
            let str = accounting.formatMoney(card.value);
            str = str.slice(0, -3);
            let str1 = accounting.formatMoney(card.lastYearValue);
            str1 = str1.slice(0, -3);
            let yoy = '';
            if ((card.lastYearValue) != 0) {
                yoy = ((((card.value) - (card.lastYearValue)) / (card.lastYearValue)) * 100)
            } else {
                yoy = 'NA'
            }
            cardSection.push(
                <GrayCard
                    displayModal={this.displayModalMethod}
                    closeModal={this.closeModal}
                    type={"amount"}
                    title={getCardTitle(card.cardTitle)}
                    amount={str}
                    date={card.year}
                    growthAmount={yoy}
                    growth={yoy >= 0 ? "positive" : "negative"}
                    excessRevenue={str3}
                />
            )

        })
        if (_isEmpty(cardSection)) {
            cardSection.push(
                <div className="col-sm-3 errorText">No data available</div>
            )
        }

        let params = this.state.params;
        params = paramsToJSON(params);
        return (
            <div>
                <ToastContainer style={{ zIndex: '9999' }} />
                {this.hideRegionTip()}
                {/* {this.state.isLoading ? matLoader() : ''} */}
                <nav className=" Filters navbar">
                    <div style={{ marginLeft: "60px" }}>
                        <span className="navbar-brand nav-head">Opportunity</span></div>
                    <div className="exportButtonWrapper">
                        <ul className="navbar-nav flexRowForFilters" style={{ marginLeft: "380px" }}>
                            <li className="nav-item">
                                <select style={{ height: '38px' }} className="form-control" data-toggle="dropdown" onChange={(e) => { this.handleChangeOfDropdownextra({ name: "buyingGroupId", value: e.target.value }) }}>
                                    <option value="0" title="IMARK &amp; IMARK LLC" selected="">IMARK PLUMBING &amp; IMARK LLC</option>
                                    <option value="2">IMARK LLC</option>
                                    <option value="1">IMARK PLUMBING</option>
                                </select>
                            </li>
                            <li className="nav-item">
                                <div className="btn-group">
                                    {this.renderButtonGroup()}
                                </div>
                            </li>
                            <li className="nav-item">
                                <Select onChange={(e) => this.handleChangeOfDropdownYear(e)}
                                    value={this.state.selectedYear}
                                    options={this.state.yearval} />
                            </li>
                            {showQuarter ?
                                <li className="nav-item">
                                    <select className="form-control" style={{ height: '38px', width: '80px' }} onChange={(e) => { this.handleChangeOfDropdown({ name: "quarter", value: e.target.value }) }} >
                                        <option value="1" selected={params.quarter == 1 ? true : false} >QTR1</option>
                                        <option value="2" selected={params.quarter == 2 ? true : false} >QTR2</option>
                                        <option value="3" selected={params.quarter == 3 ? true : false} >QTR3</option>
                                        <option value="4" selected={params.quarter == 4 ? true : false} >QTR4</option>
                                    </select>

                                </li>
                                :
                                <li className="nav-item">
                                    <Select
                                        onChange={(e) => this.handleChangeOfDropdownMonth(e)}
                                        autosize={true}
                                        value={this.state.selectedItem}
                                        options={this.state.items} />


                                </li>
                            }
                        </ul>


                        {/* <Filters defaultMonth={params.month} monthName={monthName(params.month)} setFilter={this.setFilter} /> */}
                        <ExcelFile element={<button className="btn btn-primary" style={{ marginRight: "60px", height: '38px', marginLeft: '4px' }}>Export</button>}>
                            <ExcelSheet data={opportunityVendorPartnerVolumeData} name="Missed Opportunity By Supplier">

                                <ExcelColumn label="OUT SUPPLIER" value="vendorName" />
                                <ExcelColumn label="MISSED OPPORTUNITY" value="missedOpportunity" />

                            </ExcelSheet>

                            <ExcelSheet data={opportunityUnapprovedSuppVolumeByMemberData} name="Volume By Member Data">

                                <ExcelColumn label="MEMBER NAME" value="memberName" />
                                <ExcelColumn label="MISSED OPPORTUNITY" value="missedOpportunity" />
                            </ExcelSheet>

                            <ExcelSheet data={this.props.opportunitiesUnapprovedProductGroup} name="Volume By Product Group">

                                <ExcelColumn label="PRODUCT CATEGORY" value="tierFour" />
                                <ExcelColumn label="MISSED OPPORTUNITY" value="missedOpportunity" />

                            </ExcelSheet>
                        </ExcelFile>

                    </div>
                </nav>
                {this.state.isLoading ? matLoader() :

                    <div>
                        {this.state.showPopUpBoxState ?
                            <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: "block" }}>
                                <div className="modal-dialog" role="document">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title" >Unapproved Supplier Feedback</h5>
                                            <button type="button" className="close" onClick={(e) => {
                                                this.closeModal();
                                            }}>
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                        <div className="modal-body">
                                            <form>
                                                <div className="form-group">
                                                    <label >Parent company for {this.state.selectedUnapprovedSupplier}</label>
                                                    <input onChange={(e) => {
                                                        this.setState({ parentVendorName: e.target.value });
                                                    }} type="text" className="form-control" placeholder="Enter parent supplier name" />
                                                </div>
                                            </form>
                                        </div>
                                        <div className="modal-footer">
                                            <button type="button" className="btn btn-secondary" onClick={(e) => {
                                                this.closeModal();
                                            }}>Close</button>
                                            <button type="button" className="btn btn-primary" onClick={(e) => {
                                                this.sendUnapprovedSupplierFeedback();
                                            }}>Send feedback</button>
                                        </div>
                                    </div>
                                </div>
                            </div> : <div></div>}
                        <div className="row" style={{ paddingBottom: "12px", paddingTop: "0", marginLeft: "60px", marginRight: "60px" }}>
                            {cardSection}
                        </div>
                        <div className="card-group shadow-sm mb-3" style={{ marginLeft: "70px", marginRight: "70px" }}>
                            <div className="card">
                                <div className="card-body">
                                    <div className="card-title">Sales vs Sales Opportunity</div>
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="chart chart-sm c3" id="membeRebateChart">
                                                <C3Chart data={dataForChart1.data} axis={dataForChart1.axis} />
                                            </div>

                                        </div>

                                    </div>

                                </div>
                            </div>
                            <div class="card">
                                <div class="card-body">
                                    <div class="card-title">Rebate vs Rebate Opportunity</div>
                                    <div class="row">
                                        <div className="col-sm-12">
                                            <div className="chart chart-sm c3" id="membeRebateChart">
                                                <C3Chart data={dataForChart2.data} axis={dataForChart2.axis} />
                                            </div>

                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="row" style={{ paddingTop: "0", marginLeft: "60px", marginRight: "60px" }}>
                            <div className="col-6" >
                                <div className="card-deck">
                                    {/* <div className="card-header">
                            <span>Missed Opportunity By Region </span>
                            </div> */}
                                    <div className="card shadow-sm mb-3">
                                        <div className="card-body" style={{ maxHeight: " 260" }}>
                                            <h5 style={{ textDecorationLine: 'underline', }}>Missed Opportunity By Region</h5>
                                            {/* <div className="chart-title">
                                    <span>Missed Opportunity By Region </span>
                                </div> */}
                                                {this.renderVectorMap()}
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div className="col-6">
                                {this.renderOpportunityByMember()}
                            </div>
                        </div>
                        <div className="row" style={{ paddingTop: "0", marginLeft: "60px", marginRight: "60px" }}>
                            <div className="col-6">
                                {this.renderOpportunityByOutVendors()}
                            </div>
                            <div className="col-6">
                                {this.renderOpportunityByProductGroup()}
                            </div>
                        </div>
                    </div>
                }
                {this.state.showFeedbackModal ?
                    <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: "block" }}>

                        <div className="modal-dialog" role="document" style={{ minWidth: "100px" }}>

                            <div className="modal-content" style={{ width: "700px" }}>

                                <div className="modal-header">
                                    <h5 className="modal-title" >Out Supplier Feedback</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={(e) => { this.closeFeedbackModal() }} >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body" >
                                    <Card className="mb-3">
                                        <Card.Body>
                                            <Form>
                                                <h3>Feedback for out supplier {this.state.vendorDisplayName}</h3>
                                                <Form.Group>
                                                    <Form.Label>How do you want to classify <strong>{this.state.vendorDisplayName}</strong> as?</Form.Label>
                                                    {this.state.classigicationFlag.map(classification =>
                                                        <Form.Check type="radio" key={'FLAG_' + classification.flag} onChange={() => this.handleFlagChange(classification)} name="classificationFlag" value={classification.flag} label={classification.text} />)}
                                                </Form.Group>
                                                {this.state.showSugestedVendorSelect ?
                                                    <Form.Group>
                                                        <Form.Label>Select Suggested Supplier</Form.Label>
                                                        <Dropdown name="suggestedVendorId" clearable onChange={(e, value) => this.handleClick(e, value)}
                                                            placeholder='Select Supplier' ref="vendorname" search fluid selection
                                                            options={this.props.vendorNamesList}
                                                            value={this.props.value} />
                                                        {/* <Dropdown  name="suggestedVendorId" onChange={(e, value)=>this.handleClick(e, value)} placeholder='Select Supplier' search fluid selection options={this.props.vendorNamesList} /> */}
                                                    </Form.Group> : ''}
                                                {this.state.showLPGVendorSelect ?
                                                    <Form.Group>
                                                        <Form.Label>Select Suggested LPG Supplier</Form.Label>
                                                        <Dropdown name="suggestedVendorId" ref='vendordropdown' clearable onChange={(e, value) => this.handleClick(e, value)}
                                                            placeholder='Select Supplier' search fluid selection
                                                            options={this.props.lpgvendorNames}
                                                            value={this.props.value} />
                                                        {/* <Dropdown  name="suggestedVendorId" onChange={(e, value)=>this.handleClick(e, value)} placeholder='Select Supplier' search fluid selection options={this.props.vendorNamesList} /> */}
                                                    </Form.Group> : ''}
                                                {this.state.showVendorNameInput ?
                                                    <Form.Group>
                                                        <Form.Label>Provide a existing out supplier name</Form.Label>
                                                        <Form.Control name="suggestedVendorName" ref="vendorname1" onChange={(e, value) => {
                                                            this.setState({ suggestedVendorName: e.target.value, ErrorMessage: '' });;
                                                        }} />
                                                    </Form.Group> : ''}
                                                <Button variant="primary" onClick={(e) => { this.submitForm() }} >Submit Feedback</Button>
                                                <Button variant="secondry" type="button" onClick={(e) => { this.closeFeedbackModal() }} className="btn btn-secondary" data-dismiss="modal">Close</Button>

                                            </Form>
                                            <span className="errorText">{this.state.ErrorMessage}</span>
                                        </Card.Body>
                                    </Card>

                                </div>

                                <div className="modal-footer">

                                </div>
                            </div>
                        </div>
                    </div> : ''
                }
                {this.state.showAllOutvendorFeedbackModal ?
                    <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: "block" }}>

                        <div className="modal-dialog" role="document" style={{ minWidth: "100px" }}>

                            <div className="modal-content" style={{ width: "700px" }}>

                                <div className="modal-header">
                                    <h5 className="modal-title" >Out Supplier Feedback</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={(e) => { this.closeAllFeedbackModal() }} >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body" >
                                    <Card className="mb-3">
                                        <Card.Body>
                                            <Form>
                                                <h3>Feedback for out supplier</h3>
                                                <Form.Group>
                                                    <Form.Label>How do you want to classify <strong> the out supplier</strong> as?</Form.Label>
                                                    {this.state.classigicationFlag.map(classification =>
                                                        <Form.Check type="radio" key={'FLAG_' + classification.flag} onChange={() => this.handleFlagChange(classification)} name="classificationFlag" value={classification.flag} label={classification.text} />)}
                                                </Form.Group>
                                                {this.state.showSugestedVendorSelect ?
                                                    <Form.Group>
                                                        <Form.Label>Select Suggested Supplier</Form.Label>
                                                        <Dropdown name="suggestedVendorId" clearable onChange={(e, value) => this.handleClick(e, value)}
                                                            placeholder='Select Supplier' ref="vendorname" search fluid selection
                                                            options={this.props.vendorNamesList}
                                                            value={this.props.value} />
                                                        {/* <Dropdown  name="suggestedVendorId" onChange={(e, value)=>this.handleClick(e, value)} placeholder='Select Supplier' search fluid selection options={this.props.vendorNamesList} /> */}
                                                    </Form.Group> : ''}
                                                {this.state.showLPGVendorSelect ?
                                                    <Form.Group>
                                                        <Form.Label>Select Suggested LPG Supplier</Form.Label>
                                                        <Dropdown name="suggestedVendorId" ref='vendordropdown' clearable onChange={(e, value) => this.handleClick(e, value)}
                                                            placeholder='Select Supplier' search fluid selection
                                                            options={this.props.lpgvendorNames}
                                                            value={this.props.value} />
                                                        {/* <Dropdown  name="suggestedVendorId" onChange={(e, value)=>this.handleClick(e, value)} placeholder='Select Supplier' search fluid selection options={this.props.vendorNamesList} /> */}
                                                    </Form.Group> : ''}
                                                {this.state.showVendorNameInput ?
                                                    <Form.Group>
                                                        <Form.Label>Provide a existing out supplier name</Form.Label>
                                                        <Form.Control name="suggestedVendorName" ref="vendorname1" onChange={(e, value) => {
                                                            this.setState({ suggestedVendorName: e.target.value, ErrorMessage: '' });;
                                                        }} />
                                                    </Form.Group> : ''}
                                                <Button variant="primary" onClick={(e) => { this.submitFormAll() }} >Submit Feedback</Button>
                                                <Button variant="secondry" type="button" onClick={(e) => { this.closeAllFeedbackModal() }} className="btn btn-secondary" data-dismiss="modal">Close</Button>

                                            </Form>
                                            <span className="errorText">{this.state.ErrorMessage}</span>
                                        </Card.Body>
                                    </Card>

                                </div>

                                <div className="modal-footer">

                                </div>
                            </div>
                        </div>
                    </div> : ''
                }
            </div>


        )
    }
}

function mapStateToProps(state) {
    let vendorNames = [];
    //;
    let vendorNameprops = _get(state, 'corporate.getTerminatedVPNamesForCorporate', []);
    vendorNameprops && vendorNameprops.map((vname, index) => {
        //;
        let vendorNameObj = {
            key: index,
            text: vname.vendorName,
            value: vname.vendorId,
        }
        vendorNames.push(vendorNameObj)
        //;
    })

    let chartDatafor1 = _get(state, 'corporate.getSalesRebateOpportunitiesTrend', []);
    let chartData1Arr = [];
    let chartData2Arr = [];
    let chartData1Arr2 = [];
    let chartData2Arr2 = [];
    if (!_isEmpty(chartDatafor1)) {
        chartDatafor1.map((data, index) => {
            chartData1Arr.push(_get(data, 'totalMemberSales', ''));
            chartData2Arr.push(_get(data, 'salesOpportunity', ''));
            chartData1Arr2.push(_get(data, 'totalRebate', ''));
            chartData2Arr2.push(_get(data, 'rebateOpportunity', ''));
        })
    }

    chartData1Arr.unshift('data1');
    chartData2Arr.unshift('data2');
    chartData1Arr2.unshift('data3');
    chartData2Arr2.unshift('data4');

    //For ProgressBar
    let chartDataformember = _get(state, 'corporate.opportunityUnapprovedSuppVolumeByMemberData', []);
    let chartDatamemberArr = [];
    if (!_isEmpty(chartDataformember)) {
        chartDataformember.map((data, index) => {
            chartDatamemberArr.push(_get(data, 'rebateOpportunity', ''));
        })
    }
    else {
        chartDatamemberArr.push([]);
    }
    let chartDataforvolume = _get(state, 'corporate.opportunityVendorPartnerVolumeData', []);
    let chartDatavolumeArr = [];
    if (!_isEmpty(chartDataforvolume)) {
        chartDataforvolume.map((data, index) => {
            chartDatavolumeArr.push(_get(data, 'rebateOpportunity', ''));
        })
    }
    else {
        chartDatavolumeArr.push([]);
    }
    let chartDataforpg = _get(state, 'corporate.opportunitiesUnapprovedProductGroup', []);
    let chartDatapgArr = [];
    if (!_isEmpty(chartDataforpg)) {
        chartDataforpg.map((data, index) => {
            chartDatapgArr.push(_get(data, 'rebateOpportunity', ''));
        })
    }
    else {
        chartDatapgArr.push([]);
    }
    let lpgvendorNames = [];
    // ;
    let lpgvendorNameprops = _get(state, 'member.getLPGNamesForMember', []);
    lpgvendorNameprops && lpgvendorNameprops.map((vname, index) => {
        //;
        let lpgvendorNameObj = {
            key: index,
            text: vname.vendorName,
            value: vname.vendorId,
        }
        lpgvendorNames.push(lpgvendorNameObj)
        // ;
    })
    return {
        MemberList: chartDatamemberArr,
        VolumeList: chartDatavolumeArr,
        PGList: chartDatapgArr,
        vendorNamesList: vendorNames,
        getSalesRebateOpportunitiesTrend: {
            chartData11: chartData1Arr,
            chartData22: chartData2Arr,
            chartData1: chartData1Arr2,
            chartData2: chartData2Arr2
        },
        lpgvendorNames: lpgvendorNames,
        opportunityCardsData: _get(state, 'corporate.opportunityCardsData', []),
        opportunitiesByRegion: _get(state, 'corporate.opportunitiesByRegion', []),
        opportunityUnapprovedSuppVolumeByMemberData: _get(state, 'corporate.opportunityUnapprovedSuppVolumeByMemberData', []),
        opportunityVendorPartnerVolumeData: _get(state, 'corporate.opportunityVendorPartnerVolumeData', []),
        opportunitiesUnapprovedProductGroup: _get(state, 'corporate.opportunitiesUnapprovedProductGroup', []),
        opportunityMissedOppByCategory: _get(state, 'corporate.opportunityMissedOppByCategory', []),
        stateRegionMapping: _get(state, 'corporate.stateRegionMapping', []),
        stateToStateMapping: _get(state, 'corporate.stateToStateMapping', []),
        getCorporateOpportunityMonthsFilter: _get(state, 'corporate.getCorporateOpportunityMonthsFilter', []),
        tabTracking: _get(state, 'corporate.tabTracking', []),
    }
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getOpportunitiesCardsAPI: getOpportunitiesCards,
        getSalesRebateOpportunitiesTrendAPI: getSalesRebateOpportunitiesTrend,
        getOpportunitiesByRegionAPI: getOpportunitiesByRegion,
        getOpportunitiesUnapprovedSupplierVolumeByMemberAPI: getOpportunitiesUnapprovedSupplierVolumeByMember,
        getOpportunitiesVendorPartnerVolumeAPI: getOpportunitiesVendorPartnerVolume,
        getOpportunitiesUnapprovedProductGroupAPI: getOpportunitiesUnapprovedProductGroup,
        insertFeedbackUnapprovedSupplierFeedbackAPI: insertFeedbackUnapprovedSupplierFeedback,
        getStateRegionsAPI: getStateRegions,
        getStateToStateMappingAPI: getStateToStateMapping,
        getTerminatedVPNamesForCorporateAPI: getTerminatedVPNamesForCorporate,
        saveOutVendorFeedbackAPI: saveOutVendorFeedback,
        getCorporateOpportunityMonthsFilterAPI: getCorporateOpportunityMonthsFilter,
        tabTrackingAPI: tabTracking,
        getLPGNamesForMemberAPI: getLPGNamesForMember
    }, dispatch)
}
export default connect(mapStateToProps, mapDispatchToProps)(Opportunity);
